import styled from 'styled-components'

const StyledFlexColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`

export default StyledFlexColumn
